module.exports = __webpack_public_path__ + "img/co-op.5be1a80b.png";